import Vue from 'vue';
import { EmojiPickerPlugin } from 'vue-emoji-picker';

Vue.use(EmojiPickerPlugin);
